module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// /workspace/Release/~/guest-payment/~/aphrodite/no-important.js
// module id = 343
// module chunks = 6